export const navList = [{
    label: "B2C出口",
    path: "/btoC",
    disabled: true,
}, {
    label: "9610出口业务介绍",
    path: "/btoC/introduce"
}, {
    label: "平台服务—9610出口",
    path: "/btoC/platform"
}, ]

export const tabList = [{
    label: "9610出口业务特点",
    key: 0,
}, {
    label: "开展9610出口的优势",
    key: 1,
    isFlex: true
}]

export const flowTabList = [{
    label: "平台服务—9610出口",
    key: 0,
}, ]


// WEBPACK FOOTER //
// ./src/model/bToC.js